import { call, put, delay } from 'typed-redux-saga'
import { connection, start } from '../connectionMiddleware'
import {
	signalRConnectFailed,
	signalRConnectSucceeded,
} from '../actions/signalRActions'
import { HubConnectionState } from 'updated-redux-signalr'
import { SetPsd2ConsentGivenAction } from '../actions/consumerDataPullSessionActions/psd2ConsentActions'
import { signalRConnect as signalRConnectAction } from '../actions/signalRActions'

function* connect() {
	var retries = 3
	while (retries-- > 0) {
		try {
			yield* call(start)
			return
		} catch (error: any) {
			yield put(
				signalRConnectFailed({
					name: error.name,
					errorCode: error.errorCode,
					errorText: error.name + ': ' + error.message,
					data: {},
				}),
			)
			yield delay(2000)
		}
	}
}

export function* signalRConnect(): Generator {
	if (connection.state !== HubConnectionState.Disconnected) {
		return
	}
	yield call(connect)
	yield put(signalRConnectSucceeded())
}

export function* consentSucceededSaga(): Generator {
	yield put(signalRConnectAction())
}

export function* consentGivenSaga(
	action: SetPsd2ConsentGivenAction,
): Generator {
	if (action.payload.isConsentGiven) {
		yield put(signalRConnectAction())
	}
}
